import { useContext } from "react";
import { AnalysisResultContext } from "../context/analysis-result";


export const useAnalysis = () => useContext(AnalysisResultContext);